export const fontShapeOptions = [
  {
    name: 'straight',
    svg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 150 50" enable-background="new 0 0 150 50" xml:space="preserve">
<line fill="none" stroke="#000000" stroke-width="5" stroke-miterlimit="10" x1="0" y1="25" x2="150" y2="25"/>
</svg>`
  },
  {
    name: 'curved_up_1',
    svg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 150 50" enable-background="new 0 0 150 50" xml:space="preserve">
<path fill="#FFFFFF" stroke="#000000" stroke-width="5" stroke-miterlimit="10" d="M150,33.2c0,0-35-16.4-75-16.4S0,33.2,0,33.2"/>
</svg>`
  },
  {
    name: 'curved_up_2',
    svg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 150 50" enable-background="new 0 0 150 50" xml:space="preserve">
<path fill="none" stroke="#000000" stroke-width="5" stroke-miterlimit="10" d="M150,36.9c0,0-35-23.8-75-23.8S0,36.9,0,36.9"/>
</svg>`
  },
  {
    name: 'curved_down_1',
    svg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 150 50" enable-background="new 0 0 150 50" xml:space="preserve">
<path fill="#FFFFFF" stroke="#000000" stroke-width="5" stroke-miterlimit="10" d="M0,16.8c0,0,35,16.4,75,16.4s75-16.4,75-16.4"/>
</svg>`
  },
  {
    name: 'curved_down_2',
    svg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 150 50" enable-background="new 0 0 150 50" xml:space="preserve">
<path fill="none" stroke="#000000" stroke-width="5" stroke-miterlimit="10" d="M0,13.1c0,0,35,23.8,75,23.8s75-23.8,75-23.8"/>
</svg>`
  }
]
